import { gql } from '@grandvisionhq/graphql';

const CREATE_EYE_EXAM = gql`
  mutation CreateEyeExam($eyeExamInput: CreateEyeExamInput!) {
    createEyeExam(input: $eyeExamInput) {
      code
      success
      message
      eyeExam {
        examId
        examUrl
      }
    }
  }
`;

export { CREATE_EYE_EXAM };
//# sourceMappingURL=create-eye-exam.js.map
